import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M15.418 5.643a1.25 1.25 0 00-1.34-.555l-1.798.413a1.25 1.25 0 01-.56 0l-1.798-.413a1.25 1.25 0 00-1.34.555l-.98 1.564c-.1.16-.235.295-.395.396l-1.564.98a1.25 1.25 0 00-.555 1.338l.413 1.8a1.25 1.25 0 010 .559l-.413 1.799a1.25 1.25 0 00.555 1.339l1.564.98c.16.1.295.235.396.395l.98 1.564c.282.451.82.674 1.339.555l1.798-.413a1.25 1.25 0 01.56 0l1.799.413a1.25 1.25 0 001.339-.555l.98-1.564c.1-.16.235-.295.395-.395l1.565-.98a1.25 1.25 0 00.554-1.34L18.5 12.28a1.25 1.25 0 010-.56l.413-1.799a1.25 1.25 0 00-.554-1.339l-1.565-.98a1.25 1.25 0 01-.395-.395l-.98-1.564zm-.503 4.127a.5.5 0 00-.86-.509l-2.615 4.426-1.579-1.512a.5.5 0 10-.691.722l2.034 1.949a.5.5 0 00.776-.107l2.935-4.97z",
      "clip-rule": "evenodd"
    })
  ]))
}